import { ConnectedDevice as Device } from 'app-webtech-core/modules/device/containers';
import { ConnectedGuide as Guide } from 'app-webtech-core/modules/guide/containers';
import { ConnectedPlaybackSession as PlaybackSession } from 'app-webtech-core/modules/playbackSession/containers';
import { PlutoApplication } from 'app-webtech-core/modules/application/containers';
import { ErrorBoundary as PlutoErrorBoundary } from 'app-webtech-core/modules/application/containers/ErrorBoundary';
import { PodTrackerAds } from 'app-webtech-core/modules/podTracker/ads/containers';
import { Player } from 'app-webtech-core/modules/player/containers';

export const components = {
  Device,
  Guide,
  PlaybackSession,
  PlutoApplication,
  PlutoErrorBoundary,
  PodTrackerAds,
  Player,
};
